import { render, staticRenderFns } from "./accountIndexData.vue?vue&type=template&id=662386cb&scoped=true"
import script from "./accountIndexData.vue?vue&type=script&lang=js"
export * from "./accountIndexData.vue?vue&type=script&lang=js"
import style0 from "./accountIndexData.vue?vue&type=style&index=0&id=662386cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662386cb",
  null
  
)

export default component.exports